/**
 * External Dependencies
 */
import 'jquery';

$(document).ready(() => {
  //========== MENU UNDERLINES
  $('#mobile-menu-open').on('click', function () {
    $('#main-nav-wrapper, #mobile-menu-close').removeClass('hidden');
    $('#mobile-menu-open').addClass('hidden');
    $('body').addClass('w-screen overflow-hidden');
  });
  $('#mobile-menu-close').on('click', function () {
    $('#main-nav-wrapper, #mobile-menu-close').addClass('hidden');
    $('#mobile-menu-open').removeClass('hidden');
    $('body').removeClass('w-screen overflow-hidden');
  });

  //========== MENU UNDERLINES
  $('header .underline-animation a').on('mouseover', function () {
    $(this).addClass('origin-left');
  });

  $('header .underline-animation a').on('mouseleave', function () {
    $(this).removeClass('origin-left');
  });

  var intervalID = window.setInterval(myCallback, 50);
  function myCallback() {
    var textAreaCheck = document.getElementsByClassName('g-recaptcha-response');
    if (textAreaCheck.length > 0) {
      $(textAreaCheck).attr('aria-hidden', 'true');
      console.log($(textAreaCheck));
      clearInterval(intervalID);
    }
  }
});
